<template>
    <div class="highlightIconChart">
        <!-- Needed for backdrop -->
        <div class="highlightIconChart__background hideMobile">
        </div>
        <div class="panelCard highlightIconChart__wrapper">
            <div class="padding-all-10">
                <h5 class="highlightChart__title hl-module text-color--dark-blue-gray">
                    {{ chartTitle }}
                </h5>
                <div :class="{ 'padding-vertical-10' : isMinContent }">
                    <div class="highlightIconChart__wrapper--content">
                        <div
                            v-for="(keyPlayer, index) in sortedKeyPlayers"
                            :key="index">
                            <object
                                type="image/png"
                                :data="getCdnLink(`icons/xmo/company_logos/${ keyPlayer.iconPath }.svg`)"
                                class="highlightIconChart__wrapper--playerImg vertical-middle margin-right-10"
                                :class="{ 'margin-bottom-10' : isLastPlayer(index) }">
                                <p
                                    class="highlightChart__title hl-module text-color--gray-blue margin-bottom-0"
                                    :class="getPlaceholderClass(keyPlayer.name)">
                                    {{ keyPlayer.name }}
                                </p>
                            </object>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <NextChartButton
            v-if="hasNextChart"
            :section-chart-data="sectionChartData"
            :is-disabled="isNextButtonDisabled"
            @set-chart-selection="changeKeyPlayers" />
    </div>
</template>

<script>
    import NextChartButton from 'outlook/components/marketHighlights/nextChartButton';
    import { getCdnLink } from 'tools/getCdnLink';

    const MAX_TEXT_LENGTH = 12;

    export default {
        components: {
            NextChartButton,
        },
        props: {
            sectionChartData: { type: Array, required: true },
        },
        data() {
            return {
                keyPlayersData: this.sectionChartData[0].chartData.series,
                chartTitle: this.sectionChartData[0].chartData.title,
            };
        },
        computed: {
            hasNextChart() {
                return Array.isArray(this.sectionChartData) && this.sectionChartData?.length > 0;
            },
            isNextButtonDisabled() {
                return this.chart === null || this.sectionChartData?.length === 1;
            },
            sortedKeyPlayers() {
                return this.keyPlayersData?.map((player) => {
                    const { iconPath } = player;

                    // Here I don't care if SMI does not provide an icon path in such cases I use the name as placeholder.
                    return { ...player, iconPath: iconPath.length > 0 ? iconPath : `${ player.name }.png` };
                });

            },
            isMinContent() {
                return this.keyPlayersData?.length < 4;
            },
        },
        methods: {
            getCdnLink,
            getPlaceholderClass(keyPlayerName) {
                const sanitizedName = keyPlayerName.trim();
                if (sanitizedName.length > MAX_TEXT_LENGTH) {
                    return 'width80 width-s-80';
                }

                return '';
            },
            changeKeyPlayers($event) {
                const { chartData: { series, title } } = $event;
                this.chartTitle = title;
                this.keyPlayersData = series;
            },
            isLastPlayer(index) {
                return this.keyPlayersData?.length === index + 1;
            },
        },
    };
</script>
